import React from "react";
import "./Style.css";
import { serviceHead } from "portfolio";
import { Fade } from "react-reveal";
import ServicesImg from "./ServicesImg";

export default function ServicesO(props) {
    const theme = props.theme;
    return (
        <Fade bottom duration={2000} distance="40px">
            <div className="greet-main" id="greeting">
                <div className="greeting-main">
                    <div className="greeting-text-div">
                        <div>
                            <h3 className="greeting-text" style={{ color: theme.text }}>
                                {serviceHead.title}
                            </h3>
                            <p
                                className="greeting-text-p subTitle"
                                style={{ color: theme.secondaryText }}
                            >
                                {serviceHead.subTitle}
                            </p>
                        </div>
                    </div>
                    <div className="greeting-image-div">
                        <ServicesImg theme={theme} />
                    </div>
                </div>
            </div>
        </Fade>
    );
}
